function calculateDli(pfdPoints: { time: number; value: number }[]): number {
    if (pfdPoints.length < 2) {
        return 0;
    }
    const sorted = [...pfdPoints].sort((a, b) => a.time - b.time);
    let dli = 0;
    for (let i = 0; i < sorted.length - 1; i++) {
        const dt = (sorted[i + 1].time - sorted[i].time) * 3600;
        const avgPfd = (sorted[i].value + sorted[i + 1].value) / 2;
        dli += avgPfd * dt;
    }
    return Math.round((dli / 1_000_000) * 100) / 100;
}

export default calculateDli;
